<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="gus">
<h1>Gus</h1>
<p style="text-indent: 00em;">We know this great guy called Gus</p>
<p style="text-indent: 00em;">He now drives the big school bus</p>
<p style="text-indent: 00em;">He has a jolly smile when the kids get on</p>
<p style="text-indent: 00em;">But if they’re noisy and rude that won’t last for long</p>
<p style="text-indent: 00em;">Don’t misbehave or make a fuss</p>
<p style="text-indent: 00em;">While Gus is driving the big school bus</p><br/>
<p style="text-indent: 00em;">Sometimes up the wrong road, he goes</p>
<p style="text-indent: 00em;">And the frustration on his face sure shows</p>
<p style="text-indent: 00em;">He has to back out if he can’t turn around</p>
<p style="text-indent: 00em;">There’re probably a few new words he has found</p><br/>
<p style="text-indent: 00em;">He’s missed the odd pickup stop</p>
<p style="text-indent: 00em;">And yelling from the kids he does cop</p>
<p style="text-indent: 00em;">Oh well! He’ll drop them off on the way back</p>
<p style="text-indent: 00em;">And he hopes that won’t get them a smack</p><br/>
<p style="text-indent: 00em;">But he’s admired for taking this on, from us</p>
<p style="text-indent: 00em;">As he drives around the big school bus</p>
<p style="text-indent: 00em;">Oh Gus, Oh Gus, what a character you are</p>
<p style="text-indent: 00em;">As you drive the bus instead of your car</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch011.vue?4e5b8ca9